import React, { useEffect, useState } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import routes from '../libs/routes';
import images from "../libs/images";
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingEnd } from "../redux/loadingSlice";
import { open, close } from "../redux/popupSlice";
import Popup01 from "../pages/popup/Popup01";
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isChrome, isSafari } from 'react-device-detect';
import moment from "moment";
import * as API from "../libs/service";
import { gtag } from '../analytics';
import { logEvent } from '../analytics';

import {
    logIn,
    logOut,
    gpsUpdate,
    configData,
    setData,
    aroundData,
    menuClose,
    mainReset,
    searchClose,
    pickerClose,
} from "../redux/usersSlice";
import { refreshLicenseData } from '../libs/utils';
import { setCountry, setLanguage } from '../redux/locationSlice';

export default function LoginPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const [idTitleView, setIdTitleView] = useState(false);
    const [idValue, setIdValue] = useState('');
    const [idAster, setIdAster] = useState(true);
    const [idErr, setIdErr] = useState(0);
    const [idChk, setIdChk] = useState(false);

    const [pwTitleView, setPwTitleView] = useState(false);
    const [pwview, setPwview] = useState(false);
    const [pwValue, setPwValue] = useState('');
    const [pwAster, setPwAster] = useState(true);
    const [pwErr, setPwErr] = useState(0);
    const [pwChk, setPwChk] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);
    useEffect(() => {
        if (mbData?.idx) {
            navigate(routes.main);
        }
    }, [mbData, navigate]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const error = params.get('error');
        console.log("err : ", error);
        if (error === 'EMAIL_LOGIN') {
            dispatch(open({
                component:
                    <Popup01
                        x_btn={true}
                        loginPop_navi_pw={false}
                        text1={lang === 0 ? '이메일로 가입된 계정입니다.' : 'This is an email-registered account.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                        setFunc={() => {
                            setIdAster(false);
                            setIdErr(0);
                        }}
                    />
            }));
        }
    }, [location]);

    useEffect(() => {
        const storedRegiSuc = localStorage.getItem('regiSuc');
        if (storedRegiSuc === '1') {
            const toastId = toast(lang === 0 ? '회원가입이 완료되었습니다.' : 'Registration completed successfully.');
            setTimeout(() => {
                toast.dismiss(toastId);
                localStorage.removeItem('regiSuc');
            }, 2000);
        }
        if (storedRegiSuc === '2') {
            const toastId = toast(lang === 0 ? '비밀번호가 재설정되었습니다.' : 'Password has been reset.');
            setTimeout(() => {
                toast.dismiss(toastId);
                localStorage.removeItem('regiSuc');
            }, 2000);
        }
    }, [lang]);

    const LoginFunc = async () => {
        let sender = {
            email: idValue,
            password: pwValue,
        };

        await API.post('user/Login', sender).then(({ data }) => {
            if (data?.msg === 'err1') {
                logEvent('Login', 'Failed', 'Invalid Email', null);
                setIdErr(1);
            } else if (data?.msg === 'err2') {
                logEvent('Login', 'Failed', 'Invalid Password', null);
                setPwErr(1);
            } else if (data?.msg === 'err3') {
                setIdErr(1);
            } else if (data?.msg === 'err4') {
                setIdErr(3);
            } else {
                logEvent('Login', 'Success', 'Email Login', data?.id);
                setIdErr(0);
                setPwErr(0);
                dispatch(loadingStart());
                setTimeout(() => {
                    LoginSucFunc(data);
                    dispatch(loadingEnd());
                }, 2000);
            }
        }).catch(err => {
            console.log("err : ", err);
            if (err.response && err.response.status === 404) {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            text1={lang === 0 ? 'ID 나 비밀번호가 일치하지 않습니다.' : 'Incorrect ID or password.'}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                navigate(routes.login);
                            }}
                        />
                }));
            } else {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            text1={lang === 0 ? '오류가 발생했습니다.' : 'An error has occurred.'}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                navigate(routes.login);
                            }}
                        />
                }));
            }
        });
    };

    const LoginSucFunc = async (data) => {
        await refreshLicenseData(dispatch, data?.id);
        dispatch(
            logIn({
                mbData: {
                    idx: data?.id,
                    mb_type: data?.validType,
                    mb_email: data?.email,
                    mb_name: data?.fullname,
                    pwCount: pwValue?.length,
                    lang: data?.language === 'ko' ? 0 : 1,
                    countryCode: data?.countryCode,
                    isAcceptMarketingActivities: data?.isAcceptMarketingActivities,
                    emailLanguage: data?.emailLanguage,
                },
                autoLogin: moment(),
            })
        );
        dispatch(setCountry(data?.countryCode === 'KR' ? 'KR' : 'US'));
        dispatch(setLanguage(data?.countryCode === 'KR' ? 'ko' : 'en'));
        navigate(routes.main);
        gtag('event', 'login', {
            'event_category': 'engagement',
            'event_label': '로그인'
        });
    };

    const loginPop = (type, email) => {
        if (type === "login") {
            if (!idValue || !pwValue) {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            text1={lang === 0 ? '아이디 또는 비밀번호를 입력해 주세요.' : 'Check your ID or Password'}
                            longButton={lang === 0 ? '확인' : 'OK'}
                        />
                }));
            } else {
                LoginFunc();
            }
        }
        if (type === "email") {
            if (email) {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            loginPop_navi_pw={false}
                            text1={lang === 0 ? '이메일로 가입된 계정입니다.' : 'This account was registered via email.'}
                            text1_b={email}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                setIdAster(false);
                                setIdErr(0);
                                setIdValue(email);
                            }}
                        />
                }));
            } else {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            loginPop_navi_pw={true}
                            text1={lang === 0 ? '이메일로 가입된 계정입니다.' : 'This account was registered via email.'}
                            text1_b={email}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                navigate(routes.Login_pw_help);
                            }}
                        />
                }));
            }
        }
        if (type === "google") {
            if (email) {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            loginPop_navi_google={true}
                            text1={lang === 0 ? '구글로 가입된 계정입니다.' : 'This account was registered via Google.'}
                            text1_b={email}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                navigate(routes.Login_pw_help);
                            }}
                        />
                }));
            } else {
                handleGoogleSignIn();
            }
        }
    };

    const InputChange = (event) => {
        const { name, value } = event.target;
        if (name === "login_id") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setIdValue(value);
            if (value) {
                setIdAster(false);
                setIdTitleView(true);
            } else {
                setIdAster(true);
                setIdTitleView(false);
            }
            if (!EmailChk.test(value)) {
                setIdErr(2);
                return;
            } else {
                setIdErr(0);
            }
        }
        if (name === "login_password") {
            setPwValue(value);
            if (value) {
                setPwAster(false);
                setPwTitleView(true);
            } else {
                setPwAster(true);
                setPwTitleView(false);
            }
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            loginPop("login");
        }
    };

    const handleGoogleSignIn = () => {
        const clientId = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;
        const redirectUri = process.env.REACT_APP_GOOGLE_AUTH_CALLBACK_URL;
        const scope = 'openid email profile';
        const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}&prompt=select_account`;
        window.location.href = googleAuthUrl;
    };

    return (
        <>
            <div className="login_back">
                <div className="login_box">
                    <div
                        className="logo"
                        style={{ cursor: "pointer" }}
                        onClick={() => { navigate(routes.main); }}
                    >
                        <img src={require("../assets/icon/logo_col.svg").default} alt="logo" />
                    </div>

                    <p className="title">
                        {lang === 0 ? '로그인' : 'Login'}
                    </p>

                    <div className="login_btn_div">
                        <p>{lang === 0 ? '계정이 없으세요?' : `Don't have an account?`}</p>
                        <button
                            type="button"
                            className="register_btn"
                            onClick={() => {
                                const eventName = 'sign_up_click';
                                const eventLabel = lang === 0 ? '회원가입' : 'Sign up';
                                
                                gtag('event', eventName, {
                                     'event_category': 'engagement',
                                     'event_label': eventLabel
                                });

                                navigate(routes.Register);
                            }}
                        >
                            {lang === 0 ? '회원가입' : 'Sign up'}
                        </button>
                    </div>

                    <div className="login_input_box">
                        <div className="input_div" style={{ border: idTitleView ? '1px solid #0E6AF4' : '' }}>
                            {idTitleView &&
                                <div className="input_focus id_focus">
                                    <p>{lang === 0 ? '이메일' : 'Email'}</p>
                                    <span className="input_aster" style={{ left: lang === 0 ? '32px' : '30px', top: '-2px' }}>
                                        *
                                    </span>
                                </div>
                            }
                            <input
                                type="text"
                                placeholder={`${idChk ? '' : lang === 0 ? '이메일' : 'Email'}`}
                                className="input_id"
                                name="login_id"
                                onChange={InputChange}
                                value={idValue}
                                onBlur={() => { setIdTitleView(false); setIdChk(false); if (!idValue) { setIdAster(true); } }}
                                onFocus={() => { setIdTitleView(true); setIdAster(false); if (!idValue) { setIdChk(true); } }}
                                onKeyDown={handleKeyDown}
                            />
                            {!idChk &&
                                <>
                                    {idAster &&
                                        <span className="input_aster" style={{ left: lang === 0 ? '62px' : '60px', top: idTitleView ? '20px' : '15px' }}>
                                            *
                                        </span>
                                    }
                                </>
                            }
                        </div>
                        {idErr === 1 && <span className="err_msg id">{lang === 0 ? '가입된 이메일 주소가 아닙니다.' : 'This email address is not registered.'}</span>}
                        {idErr === 2 && <span className="err_msg id">{lang === 0 ? '유효한 이메일 주소를 입력해 주세요.' : 'Please enter a valid email.'}</span>}
                        {idErr === 3 && <span className="err_msg id">{lang === 0 ? '탈퇴한 이메일 주소입니다.' : 'This email address has been withdrawn.'}</span>}

                        <div className="input_div pw_div" style={{ border: pwTitleView ? '1px solid #0E6AF4' : '' }}>
                            {pwTitleView &&
                                <div className="input_focus pw_focus">
                                    <p>{lang === 0 ? '비밀번호' : 'Password'}</p>
                                    <span className="input_aster" style={{ left: lang === 0 ? '42px' : '54px', top: '-2px' }}>
                                        *
                                    </span>
                                </div>
                            }
                            <input
                                type={!pwview ? "password" : "text"}
                                placeholder={`${pwChk ? '' : lang === 0 ? '비밀번호' : 'Password'}`}
                                className="input_pw"
                                name="login_password"
                                value={pwValue}
                                onChange={InputChange}
                                onBlur={() => { setPwTitleView(false); setPwChk(false); if (!pwValue) { setPwAster(true); } }}
                                onFocus={() => { setPwTitleView(true); setPwAster(false); if (!pwValue) { setPwChk(true); } }}
                                onKeyDown={handleKeyDown}
                            />
                            {!pwview ?
                                <img
                                    src={require("../assets/icon/eye_off.svg").default}
                                    alt="hide"
                                    onClick={() => { setPwview(true); }}
                                />
                                :
                                <img
                                    src={require("../assets/icon/eye_on.svg").default}
                                    alt="show"
                                    onClick={() => { setPwview(false); }}
                                />
                            }
                            {!pwChk &&
                                <>
                                    {pwAster &&
                                        <span className="input_aster" style={{ left: lang === 0 ? '76px' : '90px', top: pwTitleView ? '20px' : '15px' }}>
                                            *
                                        </span>
                                    }
                                </>
                            }
                        </div>
                        {pwErr === 1 && <span className="err_msg id">{lang === 0 ? '아이디 또는 비밀번호가 올바르지 않습니다.' : 'The password is incorrect.'}</span>}
                    </div>

                    <div className="login_btn_div pw_help">
                        <span onClick={() => { navigate(routes.Login_pw_help); }}>
                            {lang === 0 ? '비밀번호 찾기' : 'Forgot password'}
                        </span>
                    </div>

                    <div className="login_btn_div">
                        <button
                            type="button"
                            className="login_btn"
                            style={{ marginTop: '-28px' }}
                            onClick={() => { loginPop("login"); }}
                        >
                            {lang === 0 ? '로그인' : 'Login'}
                        </button>

                        <button
                            type="button"
                            className="sns_login_btn google"
                            style={{ marginTop: '12px' }}
                            onClick={() => { loginPop("google"); }}
                        >
                            <img src={require("../assets/icon/google.svg").default} alt="Google" />
                            {lang === 0 ? '구글 로그인' : 'Google Login'}
                        </button>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: window.innerWidth > 768 ? 400 : '100%', marginBottom: window.innerWidth > 768 ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}